var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var DocumentSmallIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 41,
    glyphHeight: 50
  }), React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M28.0525 4.35775V15.225C28.0525 16.4204 29.0235 17.3984 30.2104 17.3984H36.6842V41.3062C36.6842 43.7079 34.7529 45.6531 32.3684 45.6531H8.63158C6.24711 45.6531 4.31579 43.7079 4.31579 41.3062V8.70463C4.31579 6.30298 6.24711 4.35775 8.63158 4.35775H28.0525ZM8.63158 0.0108672H31.0737V0C31.8613 0 32.595 0.445555 32.9726 1.15192L40.7087 14.7142C40.9029 15.0511 41 15.4206 41 15.8009V41.3062C41 46.1095 37.1374 50 32.3684 50H8.63158C3.86263 50 0 46.1095 0 41.3062V8.70463C0 3.90133 3.86263 0.0108672 8.63158 0.0108672ZM32.3685 39.1328C32.3685 37.9374 31.3975 36.9594 30.2106 36.9594H10.7896C9.60273 36.9594 8.63168 37.9374 8.63168 39.1328C8.63168 40.3282 9.60273 41.3062 10.7896 41.3062H30.2106C31.3975 41.3062 32.3685 40.3282 32.3685 39.1328ZM30.2106 25.0055C31.3975 25.0055 32.3685 25.9835 32.3685 27.1789C32.3685 28.3743 31.3975 29.3524 30.2106 29.3524H10.7896C9.60273 29.3524 8.63168 28.3743 8.63168 27.1789C8.63168 25.9835 9.60273 25.0055 10.7896 25.0055H30.2106Z",
    fill: "black"
  }));
};
export var DocumentSmallIconGlyph = function (props) {
  return React.createElement(DocumentSmallIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};